import React from 'react';
import { IconVault, vaultIcon } from './Icons';

const ValueVault = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <section className="ac-vault">
      <div className="ac-vault-head">
        <IconVault />
        <h3 className="ac-vault-title">Value Vault</h3>
      </div>
      <p className="ac-vault-sub">
        Curated links, documents and resources for this topic.
      </p>

      <div className="ac-vault-list">
        {items.map((item) => (
          <a key={item.id} href={item.url || undefined} className="ac-vault-item" target="_blank" rel="noopener noreferrer" download>
            <span className="ac-vault-icon">{vaultIcon(item.type)}</span>
            <span className="ac-vault-item-text">
              <p className="ac-vault-item-title">{item.title}</p>
              <span className="ac-vault-item-type">{item.type}</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default ValueVault;
